import { IconLock, IconMail, IconUser } from '@douyinfe/semi-icons'
import { Banner, Button, Card, Form, Typography } from '@douyinfe/semi-ui'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '@/api/client'
import { useAuthStore } from '@/stores/auth'

export function LoginPage() {
  const navigate = useNavigate()
  const { setAuth } = useAuthStore()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (values: { email: string, password: string }) => {
    setLoading(true)
    setError('')
    try {
      const resp = await api.login(values.email, values.password)
      setAuth(resp.data.token, resp.data.user)
      navigate('/', { replace: true })
    }
    catch (err) {
      setError(
        err instanceof Error ? err.message : '登录失败，请检查邮箱和密码',
      )
    }
    finally {
      setLoading(false)
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--semi-color-bg-1)',
        padding: 24,
      }}
    >
      <Card
        style={{ width: 420, borderRadius: 16 }}
        shadows="always"
        bodyStyle={{ padding: 32 }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img
            src="/logo.png"
            alt="once.work"
            style={{
              width: 64,
              height: 64,
              borderRadius: 16,
              marginBottom: 16,
              objectFit: 'contain',
            }}
          />
          <Typography.Title heading={3} style={{ margin: 0 }}>
            授权运营中台
          </Typography.Title>
          <Typography.Text type="tertiary">
            once.work 授权与运营后台
          </Typography.Text>
        </div>
        {error && (
          <Banner
            type="danger"
            description={error}
            style={{ marginBottom: 24 }}
          />
        )}
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Form.Input
            field="email"
            label="邮箱"
            placeholder="admin@once.work"
            prefix={<IconMail />}
            rules={[{ required: true, message: '请输入邮箱' }]}
          />
          <Form.Input
            field="password"
            type="password"
            label="密码"
            placeholder="请输入密码"
            prefix={<IconLock />}
            rules={[{ required: true, message: '请输入密码' }]}
          />
          <Button
            type="primary"
            icon={<IconUser />}
            htmlType="submit"
            loading={loading}
            block
            theme="solid"
            style={{ marginTop: 8 }}
          >
            登录
          </Button>
        </Form>
      </Card>
    </div>
  )
}
